import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, Paper } from '@mui/material';
import ListadoEvaluaciones from './components/ListadoEvaluaciones';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allEvaluacionesAction,
  setActivoEvaluacionesAction,
} from './EvaluacionesAction';
import FormEvaluaciones from './components/FormEvaluaciones';

const EvaluacionesView = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const evaluacionesStore = Redux.useSelector((state) => state.evaluaciones);

  const [isDelete, setIsDelete] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {evaluacionesStore.all.length > 0 && (
          <BotonComponent
            click={async () => {
              await setActivoEvaluacionesAction(dispatch, null);
              await allEvaluacionesAction(dispatch, evaluacionesStore.params);
            }}
            disabled={evaluacionesStore.loadingAll}
            white
            refreshIcon
            text={
              evaluacionesStore.loadingAll ? 'Actualizando...' : 'Actualizar'
            }
          />
        )}
      </Grid>
      {loginStore.isTeacher && (
        <Grid item xs={12} md={3}>
          <Paper elevation={5} sx={{ pb: 1 }}>
            <FormEvaluaciones isDelete={isDelete} />
          </Paper>
        </Grid>
      )}
      <Grid item xs={12} md={loginStore.isTeacher ? 9 : 12}>
        <ListadoEvaluaciones
          isDelete={isDelete}
          setIsDelete={(v) => setIsDelete(v)}
        />
      </Grid>
    </Grid>
  );
};

export default EvaluacionesView;
